import { BaseEdge, type EdgeProps } from '@xyflow/react';
import { EDGE_COLOR, EDGE_CORNER_RADIUS } from '../styles';
import { getOrthogonalEdgePath } from './orthogonalEdgePath';

/**
 * Custom React Flow edge component for Logiblocks workflow edges.
 *
 * Registered in LBCanvas via `edgeTypes={{ lbEdge: LBEdge }}`. React Flow
 * renders this component for each edge object with `type: 'lbEdge'`.
 */
export function LBEdgeDisplay({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  style,
}: EdgeProps) {
  const edgePath = getOrthogonalEdgePath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    cornerRadius: EDGE_CORNER_RADIUS,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{
        stroke: EDGE_COLOR,
        strokeWidth: 1.5,
        ...style,
      }}
      markerEnd={markerEnd}
    />
  );
}
